{
  "bookmarksMenu": "Lisi",
  "change": "Suia",
  "closeBookmarksMenu": "Tapuni le lisi",
  "closeDialog": "Tapuni",
  "colonoscopy": "sūsū i le kolone (colonoscopy)",
  "continue": "Faʻaauau",
  "details": "Fa'amatalaga",
  "errors": {
    "invalidOtp": {
      "details": "<ul>  \n<li>Siaki pe iai ni sipelaga sese ma toe taumafai.</li>  \n<li>Afai e faigatā, vala’au mai i le matou numera {{phone}} (ona oomi lea o le Option 2).</li>  \n</ul>",
      "title": "E le fetaui lena ma a matou fa'amaumauga"
    },
    "serverErrorOtp": {
      "details": "<ul>  \n<li>Masalo ua sa’o au fa’amatalaga – ae sa le mafai ona matou fa’amaonia i le taimi nei.</li>  \n<li>Fa’amolemole fa’atali mo sina taimi ona toe taumafai lea.</li>  \n</ul>",
      "title": "Sa iai se mea na sese."
    }
  },
  "formattedDate": "{{date}} i le {{time}}",
  "gastroscopy": "sūsū i le manava (gastroscopy)",
  "loading": "O lo'o utaina...",
  "next": "Sosoo",
  "no": "Leai",
  "openBookmarksMenu": "Tatala le lisi",
  "optional": "Filifiliga",
  "progress": "Alualu i luma {{progress}}%",
  "selectLanguage": "Filifili le gagana",
  "step": {
    "appointment": "Taimi o le Tusi Taimi",
    "details": "Fa'amatalaga Patino",
    "health-questions": "Fesili e uiga i le soifua mālōlōina",
    "history": "Taotoga po'o ni togafitiga na faia muamua",
    "insurance": "Inisiua mo le soifua mālōlōina",
    "medications": "Fualaʻau",
    "preference-questions": "Fesili e uiga i mea e fiafia i ai",
    "specialist": "Fomaʻi Faapitoa"
  },
  "videoUnsupported": "E le lagolagoina e lau upega tafaʻilagi le pine vitio.",
  "yes": "Ioe",
  "yesTo": "Ioe i",
  "yourProgress": "O lau alualu i luma"
}
